import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/TrustHighlights/TrustHighlights.js
const TrustHighlights = createSectionForm({
  icon: "award-line",
  title: "Trust Highlights",
  fields: [
    { name: "title", label: "Section Title" },
    {
      name: "items",
      label: "Highlights",
      type: "list",
      itemLabel: "Highlight",
      fields: [
        { name: "image", label: "Icon", type: "media" },
        { name: "name", label: "Title", placeholder: "e.g. Original Products" },
      ],
    },
  ],
});

export default TrustHighlights;
